// @generated by protoc-gen-es v1.6.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/auth/session.proto (package qliq_protobuf.auth, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { User } from "./user_pb.ts";
import { AppUpgradePolicy } from "./app_upgrade_policy_pb.ts";
import { ModuleAccessMode } from "./module_access_mode_pb.ts";
import { PersonType } from "../person_type_pb.ts";

/**
 * @generated from message qliq_protobuf.auth.Session
 */
export class Session extends Message<Session> {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken = "";

  /**
   * @generated from field: string refresh_token = 2;
   */
  refreshToken = "";

  /**
   * @generated from field: string ws_token = 3;
   */
  wsToken = "";

  /**
   * @generated from field: qliq_protobuf.auth.User user = 4;
   */
  user?: User;

  /**
   * @generated from field: string device_uuid = 5;
   */
  deviceUuid = "";

  /**
   * @generated from field: qliq_protobuf.auth.User impersonated_as = 6;
   */
  impersonatedAs?: User;

  /**
   * @generated from field: qliq_protobuf.auth.Session.Group current_group = 7;
   */
  currentGroup?: Session_Group;

  /**
   * @generated from field: string app_host = 8;
   */
  appHost = "";

  /**
   * @generated from field: qliq_protobuf.auth.AppUpgradePolicy app_upgrade_policy = 9;
   */
  appUpgradePolicy?: AppUpgradePolicy;

  /**
   * @generated from field: repeated qliq_protobuf.auth.ModuleAccessMode module_access_modes = 10;
   */
  moduleAccessModes: ModuleAccessMode[] = [];

  constructor(data?: PartialMessage<Session>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.auth.Session";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "refresh_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ws_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user", kind: "message", T: User },
    { no: 5, name: "device_uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "impersonated_as", kind: "message", T: User },
    { no: 7, name: "current_group", kind: "message", T: Session_Group },
    { no: 8, name: "app_host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "app_upgrade_policy", kind: "message", T: AppUpgradePolicy },
    { no: 10, name: "module_access_modes", kind: "enum", T: proto3.getEnumType(ModuleAccessMode), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Session {
    return new Session().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Session {
    return new Session().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Session {
    return new Session().fromJsonString(jsonString, options);
  }

  static equals(a: Session | PlainMessage<Session> | undefined, b: Session | PlainMessage<Session> | undefined): boolean {
    return proto3.util.equals(Session, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.auth.Session.Group
 */
export class Session_Group extends Message<Session_Group> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: bool is_quick_forms_subscribed = 3;
   */
  isQuickFormsSubscribed = false;

  /**
   * @generated from field: bool is_scheduler_integration_enabled = 4;
   */
  isSchedulerIntegrationEnabled = false;

  /**
   * @generated from field: qliq_protobuf.auth.Session.Group parent_group = 5;
   */
  parentGroup?: Session_Group;

  /**
   * @generated from field: string address = 6;
   */
  address = "";

  /**
   * @generated from field: string phone = 7;
   */
  phone = "";

  /**
   * @generated from field: uint32 qliq_id = 8;
   */
  qliqId = 0;

  /**
   * @generated from field: bool is_emr_integration_subscribed = 9;
   */
  isEmrIntegrationSubscribed = false;

  /**
   * @generated from field: repeated string group_setting_emr_connections_enabled = 10;
   */
  groupSettingEmrConnectionsEnabled: string[] = [];

  /**
   * @generated from field: bool is_saml_sso_auth_enabled = 11;
   */
  isSamlSsoAuthEnabled = false;

  /**
   * Deprecated -> MODULE_CARE_CAMPAIGNS_ADMIN
   *
   * @generated from field: bool is_care_campaigns_subscribed = 12;
   */
  isCareCampaignsSubscribed = false;

  /**
   * Deprecated -> MODULE_AUTO_CAMPAIGNS_ADMIN
   *
   * @generated from field: bool is_auto_campaigns_subscribed = 13;
   */
  isAutoCampaignsSubscribed = false;

  /**
   * @generated from field: bool is_sms_logo_subscribed = 14;
   */
  isSmsLogoSubscribed = false;

  /**
   * @generated from field: qliq_protobuf.PersonType person_type = 15;
   */
  personType = PersonType.PERSON_PATIENT;

  /**
   * @generated from field: bool is_owned_by_current_user = 16;
   */
  isOwnedByCurrentUser = false;

  /**
   * @generated from field: bool is_usage_limits_enabled = 17;
   */
  isUsageLimitsEnabled = false;

  /**
   * @generated from field: bool is_care_campaign_appointments_subscribed = 18;
   */
  isCareCampaignAppointmentsSubscribed = false;

  constructor(data?: PartialMessage<Session_Group>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.auth.Session.Group";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_quick_forms_subscribed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "is_scheduler_integration_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "parent_group", kind: "message", T: Session_Group },
    { no: 6, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "qliq_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 9, name: "is_emr_integration_subscribed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "group_setting_emr_connections_enabled", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "is_saml_sso_auth_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "is_care_campaigns_subscribed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "is_auto_campaigns_subscribed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "is_sms_logo_subscribed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "person_type", kind: "enum", T: proto3.getEnumType(PersonType) },
    { no: 16, name: "is_owned_by_current_user", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "is_usage_limits_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "is_care_campaign_appointments_subscribed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Session_Group {
    return new Session_Group().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Session_Group {
    return new Session_Group().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Session_Group {
    return new Session_Group().fromJsonString(jsonString, options);
  }

  static equals(a: Session_Group | PlainMessage<Session_Group> | undefined, b: Session_Group | PlainMessage<Session_Group> | undefined): boolean {
    return proto3.util.equals(Session_Group, a, b);
  }
}

